import { useAppDispatch } from "@/app_redux/hooks/root_hook";

import axios, { AxiosError } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";
import { SLOTS_APIS } from "@/api_framework/api_config";

AxiosCurlirize(axios, () => {});

export const useDeleteBookingExemptionAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (bookingId: string, exemptionType: string) => {
      try {
        const accessToken = localStorage.getItem(
          configuration.localStorage.ACCESS_TOKEN.key
        );

        await axios.delete(
           `${SLOTS_APIS?.CART_EXEMPTION_DELETE.baseURL}${bookingId}`,
          {
            params: {
              exemption_type: exemptionType,
            },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        return true;
      } catch (e: any) {
        const error = e as AxiosError<any>;

        captureError(error);
        sendCurl(error?.config?.["curlCommand"]);

        const apiMessage =
          error?.response?.data?.message || "Something went wrong";

        toast.error(apiMessage);

        return false;
      }
    },
    [dispatch]
  );

  return { execute };
};
